import Vue from 'vue'

import PUBLIC from '../config/public'

Vue.directive('video',{
    //指令与元素被绑定时
    bind (ele,binding){
        ele.value = binding.value;
    },
    //指令所在元素被插入页面时
    inserted (ele,binding){
        ele.value = binding.value;

        ele.addEventListener('click' , (e) => {
            // 创建浮层元素并设置样式
            const vcVideoDom = document.createElement('div')
            vcVideoDom.style.cssText = `
            overflow: hidden;
            position:fixed;
            left : 0;
            top : 0;
            background: rgba(0, 0, 0, 0.8);
            width : 100%;
            height : 100%;
            padding : 0 20px;
            box-sizing : border-box;
            color:#fff;
            display:flex;
            justify-content: center;
            align-items : center;
            font-size:24px;
            z-index:100;
        `
            // 设置id方便寻找
            vcVideoDom.setAttribute('id', 'vc-video')
            // 将浮层插入到body中
            document.body.appendChild(vcVideoDom)
            // 插入播放器
            let video_css = PUBLIC.device == 'pc' ? 'style="width : 800px;height : 450px;"' : 'style="width : 750px;height : 400px;"';
            vcVideoDom.innerHTML = '<div class="u-window m-video-modal">\
            <div class="u-btn close"></div>\
            <div id="playCon" '+ video_css +'>\
                <iframe src="https://dhvod.17m3.com/4.2.1/player.html?vid='+ ele.value +'" allow="autoplay" allowfullscreen="true" frameborder="0" scrolling="no" class="video-iframe" width="100%" height="100%"></iframe>\
            </div>\
            </div> '

            vcVideoDom.addEventListener('click' , (e) => {
                vcVideoDom && document.body.removeChild(vcVideoDom)             
            })             
        },)


    },
    //指令所在面板被重新解析时
    update (ele,binding){
        ele.value = binding.value;     
    },
    componentUpdated: function(el, binding) {
        //TODO
    }    
});
